// Viewport height fix for mobile browsers (iOS Safari, Chrome on Android)
// Sets --vh custom property to be used for height calculations if needed
function setViewportUnit() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export function installViewportFix() {
  setViewportUnit();
  window.addEventListener('resize', setViewportUnit);
  window.addEventListener('orientationchange', setViewportUnit);
}

// Auto-install in browser contexts
if (typeof window !== 'undefined') {
  installViewportFix();
}


